import { AppThunk } from '../../../store/rootReducer';
import * as waveActions from '../actions/wave.actions';
import { selectedIdsSelector } from '../selectors/wave.selectors';

export const setWaveDepth = (direction: 'up' | 'down'): AppThunk => async (
  dispatch,
  getState,
) => {
  try {
    const selectedIds = selectedIdsSelector(getState());
    switch (direction) {
      case 'up':
        dispatch(waveActions.moveToForeground({ waveIds: selectedIds }));
        break;
      case 'down':
        dispatch(waveActions.moveToBackground({ waveIds: selectedIds }));
        break;
    }
  } catch (err) {
    console.error(err);
  }
};
